import React from 'react';
import PropTypes from 'prop-types';
import {Col, Row} from 'antd';
import {useParams} from 'react-router-dom';
import _ from 'lodash';

import {useAuthStore} from '@/context/auth';
import menus from '@/app/RouteConfig/menu';
import {getAuthMenus} from '../menuService';
import MenuItem from './MenuItem';

import styles from './FlowHeaderMenu.module.less';

MenuOverlay.propTypes = {
    menuKey: PropTypes.string.isRequired,
};

function MenuOverlay({menuKey}) {
    const params = useParams();
    const [authStore] = useAuthStore();

    const menu = menus[menuKey];
    const subMenus = getAuthMenus(authStore, menus, menuKey);
    // console.log('subMenus', subMenus, menu);

    if (_.isEmpty(subMenus)) {
        return null;
    }

    if (subMenus.length <= 5) {
        return (
            <div className={styles.overlay}>
                <Row>
                    <Col span={24} className={styles.items}>
                        {subMenus.map(item => (
                            <MenuItem key={item.path} menu={menu} menuItem={item} params={params} />
                        ))}
                    </Col>
                </Row>
            </div>
        );
    }

    // console.log(subMenus);
    const split = Math.ceil(subMenus.length / 2);
    // console.log(split);
    const menuByCol = [subMenus.slice(0, split), subMenus.slice(split)];
    // console.log(menuByCol);
    return (
        <div className={styles.overlay}>
            <Row>
                {menuByCol.map((menuArr, index) => {
                    return (
                        <Col key={index} span={12} className={styles.items}>
                            {menuArr.map(item => (
                                <MenuItem
                                    key={item.path}
                                    menu={menu}
                                    menuItem={item}
                                    params={params}
                                />
                            ))}
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
}

export default MenuOverlay;
